import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

// material uiここ
const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}));


const Item = ({ content, id, deleteTodo }) => {
    const classes = useStyles();

    const [isDone, setIsDone] = useState(false)

    const handleDelete = () => {
        deleteTodo(id);
    }
    return (
        <li>
            <input type='checkbox' onChange={() => {
                setIsDone(!isDone)
            }} />
            <span style={
                { textDecoration: isDone ? 'line-through' : 'none' }
            }>{content}</span>
            <Button variant="contained" size="small" color="secondary" className={classes.margin} onClick={handleDelete}>削除</Button>
        </li>
    )
}



export default Item